(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ao-city-map"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          entry.target.classList.add('aos-animate');
        }
      });
    });
    document.querySelectorAll('[data-aos]').forEach(el => observer.observe(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-customer-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Simple AOS replacement
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          entry.target.classList.add('aos-animate');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    
    document.querySelectorAll('[data-aos]').forEach(el => observer.observe(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ao-esim-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // Animations
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        entry.target.classList.add('aos-animate');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('[data-aos]').forEach(el => observer.observe(el));

  // Live Demand
  const viewerEl = document.getElementById('ao-viewer-count');
  if(viewerEl) {
    let base = parseInt(viewerEl.textContent);
    setInterval(() => {
      const change = Math.floor(Math.random() * 5) - 2;
      base += change;
      if(base < 80) base = 80;
      viewerEl.textContent = base;
    }, 4000);
  }

  // Timer
  function updateTimer() {
    const now = new Date();
    const end = new Date();
    end.setHours(23, 59, 59, 999);
    let diff = end - now;
    if (diff < 0) diff = 0;
    const h = Math.floor((diff / (1000 * 60 * 60)) % 24).toString().padStart(2,'0');
    const m = Math.floor((diff / (1000 * 60)) % 60).toString().padStart(2,'0');
    const s = Math.floor((diff / 1000) % 60).toString().padStart(2,'0');
    const el = document.getElementById('ao-timer');
    if(el) el.textContent = `${h}:${m}:${s}`;
  }
  setInterval(updateTimer, 1000);
  updateTimer();
});

window.addToCartAndCheckout = function(variantId) {
  const btn = document.querySelector('.btn-buy');
  btn.style.opacity = '0.7';
  btn.innerHTML = '<span class="btn-text">Processing...</span>';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  }).then(() => { window.location.href = '/checkout'; });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
